import { requests } from 'api';
import { getFirstSegment } from 'utils/urls';
import { TenantInfo, TenantTheme } from './types';

const tenantsApiBaseUrl = 'api/tenants';
const baseUrl = getFirstSegment() ? `/${getFirstSegment()}/${tenantsApiBaseUrl}` : `/${tenantsApiBaseUrl}`;

export const TenantsApi = {
  me: () => requests.get<TenantInfo>(`${baseUrl}/me`),
  getTheme: () => requests.get<TenantTheme>(`${baseUrl}/me/theme`),
  getI18n: () => requests.get<Record<string, string>>(`${baseUrl}/me/i18n`)
};